import(/* webpackMode: "eager" */ "/Users/bart/getscraping/getScraping/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/bart/getscraping/getScraping/packages/web/app/(auth)/login/buttons.tsx");
